import React from "react";
import PropTypes from "prop-types";

export const ListItem = ({ children, isLastChild }) => {
  const listItemStyle = () => ({
    marginBottom: isLastChild ? "" : "24px",
    listStylePosition: "outside",
    marginLeft: "2em",
  });

  return <li style={listItemStyle()}>{children}</li>;
};

ListItem.propTypes = {
  children: PropTypes.node.isRequired,
  isLastChild: PropTypes.bool,
};

ListItem.defaultProps = {
  isLastChild: false,
};

export default ListItem;
